//LIBRAREIS
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from 'material-ui/MenuItem';
import { localize } from 'react-localize-redux';
import { RadioButton } from 'material-ui/RadioButton';
import { RadioButtonGroup } from 'redux-form-material-ui';

//HELPERS
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import * as validator from 'helpers/Validator';
import { onlyNumbers } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';
import { titleize } from 'helpers/Formatter';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import { getTranslatedString } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';
import { featureEnabled } from 'helpers/ToggleBot';

//COMPONENTS
import PreferenceField from 'components/shared/PreferenceField';
import SlideDownAnimation from 'components/shared/SlideDownAnimation';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

//ACTION
import { resetUserCredentials } from 'actions/landlordUserActions';
import AccessiblePropertiesForm from './AccessiblePropertiesForm';
import Card from '@material-ui/core/Card';
import CheckboxNormal from 'components/ui/CheckboxNormal';

const styles = {
  sectionHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
  },
  fieldsRow: {
    marginTop: '15px',
  },
};

class UserForm extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        {this.renderAdmin()}
        <RenderIfToggleOn toggle="maintenance.maintenance_dispatch">
          {this.renderMaintenanceUserType()}
        </RenderIfToggleOn>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {' '}
              {getTranslatedString('landlordPortal.users.form.userDetailsUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          {this.renderFirstNameField()}
          {this.renderLastNameField()}
        </div>
        <div className="row">
          {this.renderEmailField()}
          {this.renderPhoneNumberField()}
          {this.renderRoleField()}
        </div>
        <div className="row">
          {this.renderMobileNumberField()}
          {this.renderOfficeNumberField()}
        </div>
        {!this.props.hideSSO && <div className="row">{this.renderSingleSignOn()}</div>}
        <SlideDownAnimation>
          {this.renderAgentSwitches()}
          {this.renderMaintenanceSwitches()}
        </SlideDownAnimation>
      </form>
    );
  }

  renderAdmin = () => {
    if (!hostIsCapreit() && this.props.userType === 'Maintenance') return null;

    const showReset = this.props.showReset;

    return (
      <div>
        <div
          className="row"
          style={{
            ...styles.sectionHeader,
            marginTop: '25px',
            marginBottom: '15px',
          }}
        >
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.users.form.administration')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <PreferenceField
              toggleName="admin"
              toggleLabelName="Admin"
              preferenceDescription={
                <div>
                  <b
                    style={{
                      color: '#ff3434',
                      fontFamily: 'Circular-Bold',
                    }}
                  >
                    {getTranslatedString('landlordPortal.users.form.warning')}:{' '}
                  </b>
                  {getTranslatedString('landlordPortal.users.form.ifAdminEnabled')}
                </div>
              }
              rootStyle={{
                marginBottom: 0,
                borderBottom: 'none',
              }}
            />
          </div>
        </div>
        {showReset && (
          <div
            className="row"
            style={{
              padding: '0px 15px',
              marginBottom: '15px',
            }}
          >
            <div
              style={{
                fontSize: '16px',
                marginBottom: '10px',
              }}
            >
              {getTranslatedString('landlordPortal.userForm.resetCredentials')}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <p>{getTranslatedString('landlordPortal.userForm.resetThisUser')}</p>
              <div
                style={{
                  color: `${AccentColor()}`,
                  cursor: 'pointer',
                }}
                onClick={() =>
                  this.props.resetUserCredentials(
                    this.props.user.user_id,
                    this.props.user.user_type
                  )
                }
              >
                {getTranslatedString('landlordPortal.userForm.reset')}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderMaintenanceUserType = () => {
    if (this.props.userType !== 'Maintenance') return;

    const renderRadioGroup = ({ input, ...rest }) => (
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
      />
    );

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.users.form.userTypeUpcase')}
            </p>
          </div>
        </div>
        <div className="row" style={{ padding: '15px 20px' }}>
          <Field
            name="maintenance_user_type"
            style={{ display: 'flex', whiteSpace: 'nowrap' }}
            component={renderRadioGroup}
          >
            <RadioButton
              value="zone_lead"
              label={getTranslatedString('landlordPortal.users.form.zoneLead')}
            />
            <RadioButton
              value="maintenance"
              label={getTranslatedString('landlordPortal.users.form.maintenance')}
            />
            <RadioButton
              value="non_pic_third_party"
              label={getTranslatedString('landlordPortal.users.form.thirdParty')}
            />
          </Field>
        </div>
      </div>
    );
  };

  renderMaintenanceSwitches = () => {
    if (this.props.userType !== 'Maintenance') return null;

    const readOnlyDescriptionOptions = {
      serviceRequest: getTranslatedString('landlordPortal.users.form.readOnlyDescription'),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.readOnlyDescriptionRFM'
      ),
    };

    const serviceRequestNotificationsDescriptionOptions = {
      serviceRequest: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsDescription'
      ),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsDescriptionRFM'
      ),
    };

    const serviceRequestNotificationsLabelOptions = {
      serviceRequest: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsLabel'
      ),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsLabelRFM'
      ),
    };

    return (
      <div>
        <div
          className="row"
          style={{
            ...styles.sectionHeader,
            marginTop: '25px',
            marginBottom: '15px',
          }}
        >
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.users.form.otherOptionsUpcase')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <PreferenceField
              toggleName="preference_attributes.maintenance_notifications"
              toggleLabelName={serviceRequestOptions(serviceRequestNotificationsLabelOptions)}
              preferenceDescription={serviceRequestOptions(
                serviceRequestNotificationsDescriptionOptions
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="read_only"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.readOnlyLabel')}
              preferenceDescription={serviceRequestOptions(readOnlyDescriptionOptions)}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="hide_branding"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.hideBrandingLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.hideBrandingDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="enable_two_factor_auth"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.twoFactorLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.twoFactorDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="claim_tickets"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.claimTicketsLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.claimTicketsDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="assign_tickets"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.assignTicketsLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.assignTicketsDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="view_all_tickets"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.viewAllTicketsLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.viewAllTicketsDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
          <div className="col-xs-12">
            <PreferenceField
              toggleName="view_non_maintenance_tickets"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.viewNonMaintenanceTicketsLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.viewNonMaintenanceTicketsDescription'
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
          </div>
        </div>
      </div>
    );
  };

  renderAgentSwitches = () => {
    if (this.props.userType !== 'Agent') return null;

    const {
      canApproveApplication,
      canReviewApplication,
      isApproverPlus,
      approvablePropertyIds,
      reviewablePropertyIds,
      v4ApplicationManagement,
    } = this.props;

    const updateApprovableProperties = (properties) => {
      const propertyObject = !!properties.properties ? properties.properties : properties;
      const approvablePropertyIds = Object.values(propertyObject).map((p) => p.value);

      this.props.changeFormValue(
        this.props.formName,
        'approvable_property_ids',
        approvablePropertyIds
      );
    };

    const updateApproverPlus = (value) => {
      this.props.changeFormValue(this.props.formName, 'is_approver_plus', value.target.checked);
    };

    const updateReviewableProperties = (properties) => {
      const propertyObject = !!properties.properties ? properties.properties : properties;
      const reviewablePropertyIds = Object.values(propertyObject).map((p) => p.value);

      this.props.changeFormValue(
        this.props.formName,
        'reviewable_property_ids',
        reviewablePropertyIds
      );
    };

    const escalateTicketsDescriptionOptions = {
      serviceRequest: getTranslatedString('landlordPortal.users.form.escalateTicketsDescription'),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.escalateTicketsDescriptionRFM'
      ),
    };

    const serviceRequestNotificationsDescriptionOptions = {
      serviceRequest: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsDescription'
      ),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsDescriptionRFM'
      ),
    };

    const serviceRequestNotificationsLabelOptions = {
      serviceRequest: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsLabel'
      ),
      requestForMaintenance: getTranslatedString(
        'landlordPortal.users.form.serviceRequestNotificationsLabelRFM'
      ),
    };
    return (
      <div>
        <div
          className="row"
          style={{
            ...styles.sectionHeader,
            marginTop: '25px',
            marginBottom: '15px',
          }}
        >
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {getTranslatedString('landlordPortal.users.form.otherOptionsUpcase')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <PreferenceField
              toggleName="preference_attributes.maintenance_notifications"
              toggleLabelName={serviceRequestOptions(serviceRequestNotificationsLabelOptions)}
              preferenceDescription={serviceRequestOptions(
                serviceRequestNotificationsDescriptionOptions
              )}
              rootStyle={{ marginBottom: 0, borderBottom: 'none' }}
            />
            <PreferenceField
              toggleName="can_manually_assign"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.canManuallyAssignLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.canManuallyAssignDescription'
              )}
            />
            <PreferenceField
              toggleName="notice_template_manager"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.noticeTemplateLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.noticeTemplateDescription'
              )}
            />
            <PreferenceField
              toggleName="can_only_send_by_notice_template"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.canOnlySendByNoticeTemplateLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.canOnlySendByNoticeTemplateDescription'
              )}
            />
            <PreferenceField
              toggleName="can_add_amenities"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.canAddAmenitiesLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.canAddAmenitiesDescription'
              )}
            />
            <PreferenceField
              toggleName="lease_signing_authority"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.leaseSignAuthorityLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.leaseSignAuthorityDescription'
              )}
            />
            <PreferenceField
              toggleName="lease_creation_authority"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.leaseCreationAuthorityLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.leaseCreationAuthorityDescription'
              )}
            />
            <PreferenceField
              toggleName="can_approve_leases"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.leaseApprovalLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.leaseApprovalDescription'
              )}
            />
            <PreferenceField
              toggleName="can_view_credit_check"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.canViewCreditCheckLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.canViewCreditCheckDescription'
              )}
            />

            <PreferenceField
              toggleName="can_approve_application"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.canApproveApplicationLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.canApproveApplicationDescription'
              )}
            />
            {canApproveApplication && v4ApplicationManagement && (
              <>
                <CheckboxNormal
                  name="is_approver_plus"
                  value={isApproverPlus}
                  checked={isApproverPlus}
                  onChange={updateApproverPlus}
                >
                  {getTranslatedString('landlordPortal.users.form.approverPlusLabel')}
                </CheckboxNormal>
                <Card style={{ marginBottom: '10px' }}>
                  <AccessiblePropertiesForm
                    onChange={updateApprovableProperties}
                    properties={this.props.properties}
                    user={{
                      properties: this.props.user.properties.filter((p) =>
                        approvablePropertyIds.includes(p.value)
                      ),
                    }}
                    formName={'approvable_properties_form'}
                  />
                </Card>
              </>
            )}

            {v4ApplicationManagement && (
              <PreferenceField
                toggleName="can_review_application"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.users.form.canReviewApplicationLabel'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.users.form.canReviewApplicationDescription'
                )}
              />
            )}

            {canReviewApplication && v4ApplicationManagement && (
              <Card style={{ marginBottom: '10px' }}>
                <AccessiblePropertiesForm
                  onChange={updateReviewableProperties}
                  properties={this.props.properties}
                  user={{
                    properties: this.props.user.properties.filter((p) =>
                      reviewablePropertyIds.includes(p.value)
                    ),
                  }}
                  formName={'revieewable_properties_form'}
                />
              </Card>
            )}

            <PreferenceField
              toggleName="call_center"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.callCenterLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.callCenterDescription'
              )}
            />
            <PreferenceField
              toggleName="show_availability"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.showAvailabilityLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.showAvailabilityDescription'
              )}
            />
            <PreferenceField
              toggleName="allow_manual_agent_bookings"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.manualBookingLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.manualBookingDescription'
              )}
            />
            <PreferenceField
              toggleName="escalate_maintenance_tickets"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.escalateTicketsLabel'
              )}
              preferenceDescription={serviceRequestOptions(escalateTicketsDescriptionOptions)}
            />
            <PreferenceField
              toggleName="receive_not_signed_up_leads_notification"
              toggleLabelName={getTranslatedString(
                'landlordPortal.users.form.nonRegisteredTenantsLabel'
              )}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.nonRegisteredTenantsDescription'
              )}
            />
            <PreferenceField
              toggleName="is_manager"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.isManagerLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.isManagerDescription'
              )}
            />
            <PreferenceField
              toggleName="enable_two_factor_auth"
              toggleLabelName={getTranslatedString('landlordPortal.users.form.twoFactorLabel')}
              preferenceDescription={getTranslatedString(
                'landlordPortal.users.form.twoFactorDescription'
              )}
            />

            <RenderIfToggleOn toggle="purchase_order">
              <PreferenceField
                toggleName="can_approve_purchase_order"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.users.form.approvePurchaseOrders'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.users.form.approvePurchaseOrdersDescription'
                )}
              />
            </RenderIfToggleOn>

            <RenderIfToggleOn toggle="ui.maintenance.new_tickets_ui">
              <PreferenceField
                toggleName="can_assign_and_schedule_tickets"
                toggleLabelName={getTranslatedString(
                  'landlordPortal.users.form.assignAndScheduleTickets'
                )}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.users.form.assignAndScheduleTicketsDescription'
                )}
              />
              <PreferenceField
                toggleName="can_log_travel_and_work_times"
                toggleLabelName={getTranslatedString('landlordPortal.users.form.timeTracking')}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.users.form.timeTrackingDescription'
                )}
              />
              <PreferenceField
                toggleName="can_change_ticket_status"
                toggleLabelName={getTranslatedString('landlordPortal.users.form.statusChange')}
                preferenceDescription={getTranslatedString(
                  'landlordPortal.users.form.statusChangeDescription'
                )}
              />
            </RenderIfToggleOn>
          </div>
        </div>
      </div>
    );
  };

  renderFirstNameField = () => {
    return (
      <div className="col-sm-6" style={{ marginBottom: '20px' }}>
        <Field
          disabled={this.isFieldDisabled()}
          name="first_name"
          variant="outlined"
          component={TextField}
          label={getTranslatedString('landlordPortal.users.form.firstName')}
          multiLine={false}
          fullWidth
          validate={[validator.required]}
        />
      </div>
    );
  };

  renderLastNameField = () => {
    return (
      <div className="col-sm-6" style={{ marginBottom: '20px' }}>
        <Field
          disabled={this.isFieldDisabled()}
          name="last_name"
          variant="outlined"
          component={TextField}
          label={getTranslatedString('landlordPortal.users.form.lastName')}
          validate={[validator.required]}
        />
      </div>
    );
  };

  renderEmailField = () => {
    return (
      <div className="col-sm-6" style={{ marginBottom: '20px' }}>
        <Field
          disabled={this.isFieldDisabled()}
          name="email"
          variant="outlined"
          component={TextField}
          label={getTranslatedString('landlordPortal.users.form.email')}
          validate={[validator.required, validator.validEmail]}
        />
      </div>
    );
  };

  renderRoleField = () => {
    if (this.props.userType === 'Maintenance') return null;

    return (
      <div className="col-sm-6" style={{ marginBottom: '20px' }}>
        <FormControl>
          <Field
            name="role"
            label={getTranslatedString('landlordPortal.users.form.role')}
            component={OutlinedSelect}
            validate={[validator.required]}
          >
            <MenuItem value="custom">
              {getTranslatedString('landlordPortal.users.form.custom')}
            </MenuItem>
            {this.props.roles.map((role) => (
              <MenuItem key={`role_${role.value}`} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </Field>
        </FormControl>
      </div>
    );
  };

  renderPhoneNumberField = () => {
    if (this.props.userType === 'Agent') return null;

    return (
      <div className="col-sm-6" style={{ marginBottom: '20px' }}>
        <Field
          disabled={this.isFieldDisabled()}
          name="phone_number"
          component={ReactPhoneInput}
          label={getTranslatedString('landlordPortal.users.form.phoneNumber')}
          validate={[validator.required, validator.validInternationalPhoneNumber]}
        />
      </div>
    );
  };

  renderMobileNumberField = () => {
    if (this.props.userType === 'Maintenance') return null;

    return (
      <div className="col-sm-12" style={{ marginBottom: '20px' }}>
        <Field
          disabled={this.isFieldDisabled()}
          name="mobile_number"
          component={ReactPhoneInput}
          label={getTranslatedString('landlordPortal.users.form.mobileNumber')}
          validate={
            this.isFieldDisabled()
              ? []
              : [validator.required, validator.validInternationalPhoneNumber]
          }
        />
      </div>
    );
  };

  renderOfficeNumberField = () => {
    if (this.props.userType === 'Maintenance') return null;

    return (
      <Fragment>
        <div className="col-xs-8" style={{ marginBottom: '20px' }}>
          <Field
            disabled={this.isFieldDisabled()}
            name="office_number"
            component={ReactPhoneInput}
            label={getTranslatedString('landlordPortal.users.form.officeNumber')}
            validate={
              this.isFieldDisabled()
                ? []
                : [validator.required, validator.validInternationalPhoneNumber]
            }
          />
        </div>
        <div className="col-xs-4">
          <Field
            disabled={this.isFieldDisabled()}
            name="office_number_extension"
            component={TextField}
            variant="outlined"
            label="Ext."
            normalize={onlyNumbers}
          />
        </div>
      </Fragment>
    );
  };

  singleSignOnFormat = () => {
    return this.props.providerIsSSO === true && this.props.user.provider !== 'username'
      ? getTranslatedString('landlordPortal.users.form.singleSignOn.enabled')
      : getTranslatedString('landlordPortal.users.form.singleSignOn.disabled');
  };

  renderSingleSignOn = () => {
    if (!this.props.user) return null;
    if (this.props.userType === 'Maintenance') return null;

    return (
      <div className="col-sm-6">
        <Field
          disabled={this.isFieldDisabled()}
          name="providerIsSSO"
          component={TextField}
          format={this.singleSignOnFormat}
          variant="outlined"
          label={
            this.props.user.provider === 'username'
              ? getTranslatedString('landlordPortal.users.form.singleSignOn')
              : getTranslatedString('landlordPortal.users.form.singleSignOnProvider', {
                  provider: titleize(this.props.user.provider),
                })
          }
        />
      </div>
    );
  };

  isFieldDisabled = () => {
    if (this.props.currentUserType === 'Maintenance' && this.props.userType === 'Maintenance') {
      return false;
    }

    if (this.props.providerIsSSO === true && this.props.userType === 'Agent') {
      return true;
    }

    return false;
  };
}

let ConnectedUserForm = compose(
  connect(
    (state, ownProps) => {
      const selector = formValueSelector(ownProps.formName);

      return {
        form: ownProps.formName,
        userType: selector(state, 'user_type'),
        canApproveApplication: selector(state, 'can_approve_application'),
        canReviewApplication: selector(state, 'can_review_application'),
        isApproverPlus: selector(state, 'is_approver_plus'),
        approvablePropertyIds: (selector(state, 'approvable_property_ids') || []).map((id) =>
          parseInt(id)
        ),
        reviewablePropertyIds: (selector(state, 'reviewable_property_ids') || []).map((id) =>
          parseInt(id)
        ),
        roles: deepDiver(state, 'landlordUsers.roles'),
        providerIsSSO: ownProps.initialValues.providerIsSSO,
        user: state.landlordUsers.user,
        v4ApplicationManagement: featureEnabled('application-management'),
      };
    },
    {
      resetUserCredentials,
      changeFormValue: change,
    }
  ),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(UserForm);

export default localize()(ConnectedUserForm);
